export default __webpack_public_path__ + "static/media/Screenshot_3.3bd75d8f.png";